export type OptionState =
	| 'selected'
	| 'unselected'
	| 'only-unselectable-unselected'
	| 'only-unselectable-selected'
	| 'disabled'
	| 'invalid';

export const getOptionState = (
	isDisabled: boolean,
	isOnlyUnselectable: boolean,
	isSelected: boolean,
	isInvalid: boolean,
): OptionState => {
	if (isDisabled) {
		return 'disabled';
	}
	if (isOnlyUnselectable && !isSelected) {
		return 'only-unselectable-unselected';
	}
	if (isInvalid) {
		return 'invalid';
	}
	if (isOnlyUnselectable && isSelected) {
		return 'only-unselectable-selected';
	}
	if (isSelected) {
		return 'selected';
	}
	return 'unselected';
};
